import React from "react";

export const Connected = ({ ...rest }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="16" height="16" rx="8" fill="#47BE79" />
      <path
        d="M4.25 8L6.75 10.5L11.75 5.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
